<div class="slider-items admin-playlist-card-container"
  [ngClass]="{'slider-item-selector1': !slidItemClass}"
  (click)="playlistClick(tile_playlists)">
  <div class="slider-img1 tile-category" [attr.tile_playlists-slug]="tile_playlists.slug" lazy-load-images (click)="playlistClick(tile_playlists);">
    <img alt="tile_playlists.title" style="height:140px;width:300px;cursor:pointer;border-radius:5px;" [src]="tile_playlists.image_url" onError="this.src='https://dyo1wwfvu9av7.cloudfront.net/jkp/common/default-poster.png'">
    <!--span *ngIf="type === 'favorite'" class="like-box" (click)="favourite(video, $event)">
      <i [ngClass]="'liked'"></i>
    </span-->
    <!--span class="total-videos">{{playlists.playlist_videos_count}} {{ 'ADMIN_PLAYLIST.VIDEOS' | translate }}</span-->
  </div>
  <!--div class="slider-content">
    <h3 class="category-text" (click)="playlistClick(tile_playlists);">
      {{tile_playlists?.title}}
    </h3>
  </div-->
</div>
